(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-auplay-clider"] && !Shopify.designMode) return;
  try {
    


document.addEventListener("DOMContentLoaded", function () {
  var section = document.querySelector('#section-slider');

  if (!section) return;

  var track   = section.querySelector('.colm-track');
  var btnPrev = section.querySelector('.colm-arrow--prev');
  var btnNext = section.querySelector('.colm-arrow--next');
  var cards   = section.querySelectorAll('.colm-card');
  var wrap    = section.querySelector('.colm-track-wrap');

  if (!track || !cards.length) return;

  var currentIndex = 0;

  function getCardStep() {
    var cardWidth = cards[0].offsetWidth;
    var gap = parseInt(getComputedStyle(track).gap) || 28;
    return cardWidth + gap;
  }

  function getVisibleCount() {
    return Math.floor((wrap.offsetWidth + parseInt(getComputedStyle(track).gap || 28)) / getCardStep());
  }

  function getMaxIndex() {
    return Math.max(0, cards.length - getVisibleCount());
  }

  function goTo(index, animate) {
    var max = getMaxIndex();
    currentIndex = Math.max(0, Math.min(index, max));
    var offset = currentIndex * getCardStep();
    if (animate === false) {
      track.style.transition = 'none';
    } else {
      track.style.transition = 'transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    }
    track.style.transform = 'translateX(-' + offset + 'px)';
    btnPrev.disabled = currentIndex === 0;
    btnNext.disabled = currentIndex >= max;
  }

  btnPrev.addEventListener('click', function () { goTo(currentIndex - 1); });
  btnNext.addEventListener('click', function () { goTo(currentIndex + 1); });

  /* Drag - mouse */
  var dragStartX = 0;
  var isDragging = false;
  var baseOffset = 0;
  var didDrag = false;

  track.addEventListener('mousedown', function (e) {
    isDragging = true;
    didDrag = false;
    dragStartX = e.clientX;
    baseOffset = currentIndex * getCardStep();
    track.style.transition = 'none';
    track.style.cursor = 'grabbing';
    e.preventDefault();
  });

  window.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    var delta = dragStartX - e.clientX;
    if (Math.abs(delta) > 5) didDrag = true;
    var maxOffset = getMaxIndex() * getCardStep();
    var newOffset = Math.min(Math.max(baseOffset + delta, 0), maxOffset);
    track.style.transform = 'translateX(-' + newOffset + 'px)';
  });

  window.addEventListener('mouseup', function (e) {
    if (!isDragging) return;
    isDragging = false;
    track.style.cursor = '';
    if (didDrag) {
      var delta = dragStartX - e.clientX;
      var step = getCardStep();
      var moved = Math.round(delta / step);
      if (Math.abs(delta) < step * 0.25) moved = 0;
      goTo(currentIndex + moved);
      track.addEventListener('click', blockClick, true);
    }
  });

  function blockClick(e) {
    e.preventDefault();
    e.stopPropagation();
    track.removeEventListener('click', blockClick, true);
  }

  /* Swipe - touch */
  var touchStartX = 0;
  var touchBaseOffset = 0;

  track.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
    touchBaseOffset = currentIndex * getCardStep();
    track.style.transition = 'none';
  }, { passive: true });

  track.addEventListener('touchmove', function (e) {
    var delta = touchStartX - e.touches[0].clientX;
    var maxOffset = getMaxIndex() * getCardStep();
    var newOffset = Math.min(Math.max(touchBaseOffset + delta, 0), maxOffset);
    track.style.transform = 'translateX(-' + newOffset + 'px)';
  }, { passive: true });

  track.addEventListener('touchend', function (e) {
    var delta = touchStartX - e.changedTouches[0].clientX;
    var step = getCardStep();
    var moved = Math.round(delta / step);
    if (Math.abs(delta) < step * 0.25) moved = 0;
    goTo(currentIndex + moved);
  });

  /* Init */
  goTo(0, false);

  /* Resize */
  window.addEventListener('resize', function () { goTo(currentIndex, false); });
})();

  } catch(e) { console.error(e); }
})();
})();
